import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const DocketEntryTypeNotificationsState = {
  docketEntryTypeNotifications: [],
}

export const DocketEntryTypeNotificationsActions = {
  getDocketEntryTypeNotifications: async ({ commit }) => {
    return axiosRequest.
      get('/docket_entry_types/notifications').
      then(({ data }) => commit('setDocketEntryTypeNotifications', data)).
      catch(handleError)
  },
}

export const DocketEntryTypeNotificationsMutations = {
  setDocketEntryTypeNotifications: (state, payload) => { state.docketEntryTypeNotifications = payload },

  setDocketEntryTypeNotification: (state, payload) => {
    const idx = state.docketEntryTypeNotifications.findIndex(t => t.id === payload.id)

    if (idx < 0) state.docketEntryTypeNotifications.push(payload)
    else Vue.set(state.docketEntryTypeNotifications, idx, payload)
  },
}

export const DocketEntryTypeNotificationsGetters = {
  docketEntryTypeNotifications: state => state.docketEntryTypeNotifications,
}
